export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9597.fded3dc8.jpg";